<!-- eslint-disable -->
<template lang="pug">
    cs-modal(@close="closeCreateMessageModal", :is-blur="true")
        template(v-if="!this.successfullyAdded")
            div(slot='header')
                | {{ $i18n.t('support.support_createTicket_ticketCreation') }}
            .create-message
                label.create-message__label
                    svg-icon.create-message__icon(name="clock-o", size="large")
                    .create-message__text
                        | {{ $i18n.t('support.support_conversations_workingTime') }}
                        br
                        | {{ $i18n.t('support.support_conversations_helpTime') }}
                        br
                        span(v-html="FAQmessage")
                label.create-message__label
                    | {{ $i18n.t('support.support_createTicket_departments') }}
                cs-multiselect(
                    :options='departments',
                    label='name',
                    :show-labels='false',
                    :placeholder="$i18n.t('support.support_createTicket_chooseDepartment')",
                    track-by='id',
                    :max-height='150',
                    :multiple='false',
                    :allow-empty="false",
                    v-model='form.department',
                    v-validate="'required'",
                    data-vv-value-path='innerValue',
                    data-vv-name='receivers',
                    data-vv-as='получатели'
                )
                    span(slot='noResult')
                        | {{ $i18n.t('conversations.conversations_createMessage_notFound') }}
                template(v-if="user.isAgent")
                    label.create-message__label
                        | {{ $i18n.t('support.support_createTicket_recipient') }}
                    cs-multiselect(
                        :options='users',
                        :multiple='false',
                        :show-labels='false',
                        :hide-selected='true',
                        :searchable='true',
                        label='fullName',
                        track-by='id',
                        :max-height='150',
                        :loading='loadingUsers',
                        :placeholder="$i18n.t('support.support_createTicket_selectRecipient')",
                        @open='asyncFindUser',
                        @search-change='asyncFindUser',
                        v-model='form.recipient',
                        v-validate="'required'",
                        data-vv-value-path='innerValue',
                        data-vv-name='receivers',
                        data-vv-as='получатели'
                    )
                        span(slot='noResult')
                            | {{ $i18n.t('conversations.conversations_createMessage_notFound') }}
                label.create-message__label
                    | {{ $i18n.t('support.support_createTicket_theme') }}
                cs-input(v-model='form.theme')
                label.create-message__label
                    | {{ $i18n.t('support.support_createTicket_message') }}
                textarea.create-message__textarea(v-model='form.body', v-autosize="", v-focus="")
            .create-message__buttons
                label.label-button(for='file-select')
                    svg-icon.label-button__icon(name="paperclip", height="19px", width="19px")
                    span
                        | {{ $i18n.t('conversations.conversations_conversation_attachFiles') }}
                    input#file-select(type='file', ref='fileSelect', @change='setFiles', multiple)
                cs-button(
                    color="blue"
                    :disabled="!(form.theme && form.department && form.body.length)",
                    @click="sendTicket"
                )
                    | {{ $i18n.t('conversations.conversations_conversation_sendMessage') }}
            .create-message__attachment-files(v-if='form.files.length')
                .create-message__attachment(v-for='(file, index) in form.files')
                    | {{ file.name }}
                    a.create-message__delete-file(href='javascript://', @click='deleteFile(index)')
                        svg-icon(name="cancel", size="x-large")
                    progress(v-if="filesProgressLoaders[index] && filesProgressLoaders[index]['loaded'] < filesProgressLoaders[index]['total']",
                        max='100', :value="filesProgressLoaders[index]['loaded'] / filesProgressLoaders[index]['total'] * 100")
        .create-message__send(v-else)
            span
                svg-icon.create-message__send_successfully-added(name="check", size="xx-large")
            span.create-message__send_text
                | {{ $i18n.t('conversations.conversations_createMessage_messageWasSend') }}
</template>

<script>
    /*eslint-disable*/
    import DepartmentsApi from '../api/communication/departments';
    import UserApi from "../api/user/user";

    import CsModal from '../elements/CsModal.vue'

    import { mapState } from 'vuex';
    import { FAQ_URL } from '@/config/urls';

    import linkifyStr from 'linkifyjs/string'

    export default {
        components: {CsModal},
        mounted () {
            this.fetchDepartments();
            window.addEventListener('beforeunload', this.setDataToSessionStorage, {once: true});
            this.form.body = window.sessionStorage.getItem(`ticketMessage`) || '';
        },
        beforeDestroy () {
            this.setDataToSessionStorage();
            window.removeEventListener('beforeunload', this.setDataToSessionStorage)
        },
        data () {
            return {
                users: [],
                departments: [],
                successfullyAdded: false,
                form: {
                    department: {},
                    recipient: null,
                    theme: '',
                    body: '',
                    files: [],
                },
                loadingUsers: false,
                filesProgressLoaders: [],
            };
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            FAQmessage () {
                return linkifyStr(this.$i18n.t('support.support_conversations_FAQ', { url: FAQ_URL }), {})
            }
        },
        methods: {
            fetchDepartments () {
                DepartmentsApi.list().then((data) => {
                    this.departments = data;
                    this.user.isAgent && (this.departments = this.user.departments);
                    this.departments.forEach(department => {
                        department.name = this.$i18n.t('support.support_departmentName_' + department.type);
                    });
                    this.form.department = this.departments[0];
                });
            },
            setDataToSessionStorage () {
                window.sessionStorage.setItem(`ticketMessage`, this.form.body)
            },
            deleteFile (index) {
                this.form.files.splice(index, 1);
                this.filesProgressLoaders.splice(index, 1);
            },
            setFiles (e) {
                Array.from(e.target.files).forEach((file, index) => this.setFile(file, index + this.filesProgressLoaders.length));
            },
            setFile (file, index) {
                if (this.isInFiles(file)) {
                    return;
                }
                let reader = new FileReader();
                reader.addEventListener('loadstart', this.handleFileLoadStart);
                reader.addEventListener('loadend', (event) => this.handleFileLoadEnd(event, index));
                reader.addEventListener('progress', (event) => this.handleFileLoadProgress(event, index));
                reader.readAsDataURL(file);
                this.form.files.push(file);
            },
            handleFileLoadStart (event) {
                this.filesProgressLoaders.push({loaded: event.loaded, total: event.total});
            },
            handleFileLoadEnd (event, index) {
                this.filesProgressLoaders[index].loaded = this.filesProgressLoaders[index].total;
            },
            handleFileLoadProgress (progress, index) {
                this.filesProgressLoaders[index].loaded = progress.loaded;
                this.filesProgressLoaders[index].total = progress.total;
            },
            isInFiles (file) {
                for (let localFile of this.form.files) {
                    if (localFile.name === file.name && file.size === localFile.size) {
                        return true;
                    }
                }
                return false;
            },
            asyncFindUser(query) {
                if (this.users.length) {
                    return;
                }
                this.loadingUsers = true;
                let form = {
                    fullName: query,
                    type: 'user',
                    status: 'active',
                    gradeIds: this.schoolId && this.gradeId ? [this.schoolId, this.gradeId] : null,
                    all: true,
                    isForConversation: true
                };
                UserApi.list(form).then((data) => {
                    data.users && (this.users = data.users);
                    this.users = this.users.filter((item) => {
                        if (!item.isAgent) {
                            item.fullName = `${item.firstName} ${item.lastName}`;
                            return item;
                        }
                    });
                    this.loadingUsers = false;
                });
            },
            closeCreateMessageModal() {
                this.successfullyAdded ? this.$emit('send', this.form) && this.$emit('close')
                        : this.$emit('close');
            },
            sendTicket () {
                this.successfullyAdded = !this.successfullyAdded;
                setTimeout(() => {
                    this.$emit('send', this.form)
                    this.$emit('close')
                }, 5000);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .create-message__label {
        font-size: 16px;
        line-height: 19px;
        text-align: left;
        display: flex;
        margin: 20px 0 10px 0;
    }

    .create-message__icon {
        margin-right: 10px;
    }


    .create-message__textarea {

        box-sizing: border-box;

        outline: none;

        color: $x-color-black;

        width: 100%;

        border-radius: $border-radius-5;
        border: 1px solid $hsl-color-gray-74;

        font-weight: normal;
        font-size: $font-size-16;
        line-height: $font-size-19;

        //@include inset-squish-space($space-small);

        padding: 12px 15px;

        @include stack-space($space-x-small);

        &:hover {
            border-color: $hsl-color-blue-56;
        }

        &:focus {
            border-color: $hsl-color-blue-56;
        }

        &:active {
            border-color: $hsl-color-blue-56;
        }

        &::placeholder {
            font-weight: lighter;
        }

        align-items: center;
        height: 2.25em;
        justify-content: flex-start;
        position: relative;
        vertical-align: top;
        background-color: #fff;
        box-shadow: inset 0 1px 2px hsla(0,0%,4%,.1);
        max-width: 100%;

        display: block;
        min-width: 100%;

        word-wrap: break-word;
        resize: none;
        max-height: 200px;
        min-height: 180px;

        overflow: hidden;
        overflow-wrap: break-word;
    }

    .create-message__buttons {
        display: flex;
        flex-direction: column;
        margin-top: 30px;
        @include media($md) {
            justify-content: space-between;
            flex-direction: row;
        }
    }

    .create-message__attachment-files {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        margin-top: 20px;
    }

    .create-message__attachment {
        display: flex;
        align-items: center;
        margin-right: 20px;
    }

    .create-message__delete-file {
        color: $hsl-color-gray-74;
        &:hover {
            color: $hsl-color-red-62;
        }
    }

    .label-button {
        box-sizing: border-box;

        padding: 15px 30px;

        transition: 0.3s;

        font-weight: normal;
        font-size: 16px;
        line-height: 19px;

        border-radius: $border-radius-40;

        cursor: pointer;
        outline: none;

        display: flex;
        vertical-align: middle;
        text-align: center;
        justify-content: center;
        align-items: center;

        color: $hsl-color-blue-56;
        background-color: transparent;
        border: 1px solid $hsl-color-blue-56;


        margin-bottom: 10px;
        @include media($md) {
            margin-bottom: 0;
        }
    }

    .label-button:hover {
        color: $x-color-white;
        background-color: $hsl-color-blue-48;
    }

    .label-button__icon {
        margin-right: 14px;
    }

    #file-select {
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        display: block;
    }

    .create-message__send {
        display: flex;
        flex-direction: column;
    }

    .create-message__send_successfully-added {
        border-radius: 50%;
        color: $hsl-color-green-58;
        border: 4px solid $hsl-color-green-58;
        padding: 8px;
        margin-bottom: 20px;
    }

    .create-message__send_text {
        font-size: 22px;
        font-weight: 500;
    }


</style>
